import http from '../utils/http';
import { Promise as bbPromise } from 'bluebird';
import { notifySuccess, notifyError } from './common';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

const defaultState = {
    entityName: 'tags',
    baseUrl: 'api/tags/',
    tableName: 'tagsTable',
    ...baseState,
    // items bellow is cached data and need to be refreshed whenever we update tags.
    spaceTags: [],
    deviceTags: [],
    tagCounts: {},
    tagCountsPending: false,
    helpUrl: '/user-guide/guide/tags.html'
};

export const mutations = {
    ...baseMutations,
    setSpaceTags(state, value) {
        state.spaceTags = Array.isArray(value) ? value : [];
    },
    setDeviceTags(state, value) {
        state.deviceTags = Array.isArray(value) ? value : [];
    },
    setTagCounts(state, value) {
        if (value) {
            state.tagCounts = value;
        } else {
            state.tagCounts = {};
        }
    },
    setTagsStatePending(state, { key, value }) {
        if (typeof value === 'boolean') {
            state[key] = value;
        } else {
            state[key] = false;
        }
    }
};

export const actions = {
    ...baseActions,
    fetchTags({ commit, dispatch, state }, { searchParams, filterParams }) {
        console.log('calling fetchTags', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams,
            notifyConfig,
            saveParams: true
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    fetchSpaceTags({ commit, state }) {
        console.log('calling fetchSpaceTags');
        return http
            .get(`${state.baseUrl}search?size=9999&type=SPACE`)
            .then(res => {
                commit('setSpaceTags', res.data.content);
                return res;
            });
    },
    fetchDeviceTags({ commit, state }) {
        console.log('calling fetchDeviceTags');
        return http
            .get(`${state.baseUrl}search?size=9999&type=DEVICE`)
            .then(res => {
                commit('setDeviceTags', res.data.content);
                return res;
            });
    },
    fetchTagCounts({ commit, state }) {
        console.log('calling fetchTagCounts');
        commit('setTagsStatePending', {
            key: 'tagCountsPending',
            value: true
        });
        return http
            .get(`${state.baseUrl}tagCounts`)
            .then(res => {
                commit('setTagCounts', res.data);
            })
            .finally(() => {
                commit('setTagsStatePending', {
                    key: 'tagCountsPending',
                    value: false
                });
            });
    },
    bulkDelete({ dispatch }, { tagIds }) {
        dispatch('notifier/requestPending', null, { root: true });
        const successMessage = 'Bulk delete was executed successfully.';
        const failMessage =
            'Error occured while executing a bulk delete on tags';
        const deleteNotifyConfig = {
            notifyRequestPending: false,
            notifySuccess: false,
            notifyError: false
        };
        return bbPromise
            .each(tagIds, id => {
                return dispatch(
                    'tag/deleteTag',
                    { tagId: id, notifyConfig: deleteNotifyConfig },
                    { root: true }
                );
            })
            .then(() => {
                notifySuccess(dispatch, successMessage);
            })
            .catch(error => {
                notifyError(dispatch, failMessage, error);
            });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
